import React, { useContext, useMemo } from "react";
import clsx from "clsx";
import isEmpty from "lodash/isEmpty";
import Typography from "@material-ui/core/Typography";
import ProductDetailContext from "@micado-digital/react-shop/ProductDetail/context/ProductDetailContext";

import styles from "./Attributes.styles";

const Attributes = () => {
	const { productDetailData } = useContext(ProductDetailContext);
	const { attributes: _attributes } = productDetailData || {};
	const css = styles();

	const attributes = useMemo(() => {
		return _attributes?.map(({ title, value }) => {
			return `<span>${title}</span>: ${value}`;
		});
	}, [_attributes]);

	if (isEmpty(attributes)) return <></>;

	return (
		<Typography
			className={clsx(css.attributes, "mco-shop-product-detail-attributes")}
			dangerouslySetInnerHTML={{
				__html: `${!isEmpty(attributes) ? `${attributes?.join(", ")}` : ``}`
			}}
			variant="body2"
		/>
	);
};

export default Attributes;
